export const getMediaUrl = (url) => {
    if (!url) return '';
    
    // If it's already a full URL (starts with http:// or https://), return as is
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
    }
    
    // Otherwise, it's a relative path, prepend backend URL
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
    const cleanBackendUrl = backendUrl.replace(/\/$/, '');
    const cleanMediaUrl = url.replace(/^\//, '');
    return `${cleanBackendUrl}/${cleanMediaUrl}`;
};